<template>
  <section class="galeria-hero relative overflow-hidden" :style="{ backgroundImage: `url(${heroImage})` }">
    <div class="hero-overlay"></div>
    <div class="relative flex flex-col items-center justify-center h-full text-center text-white px-6">
      <span class="eyebrow eyebrow-light mb-5">Portafolio</span>
      <h1 class="hero-title text-5xl md:text-7xl font-bold text-white">Trabajos</h1>
      <span class="divider-line divider-line-light mt-6"></span>
      <p class="mt-6 text-base md:text-xl text-white/90 max-w-2xl italic font-light">
        Inspírate con cada uno de mis trabajos
      </p>
    </div>
  </section>

  <div class="max-w-7xl mx-auto px-4 py-16">
    <template v-for="(category, idx) in categories" :key="category.title">
      <section class="gallery-section">
        <div class="text-center mb-8">
          <span class="eyebrow mb-2">0{{ idx + 1 }} · Categoría</span>
          <h2 class="font-display text-3xl md:text-4xl text-purple-custom font-semibold mt-2">{{ category.title }}</h2>
          <span class="divider-line mt-4 inline-block"></span>
        </div>
        <CarouselPersonalizado
          :autoplay="4000"
          :wrap-around="true"
          :pause-on-hover="true"
          :items-to-show="itemsToShow"
          :pagination="false"
        >
          <SlidePersonalizado v-for="item in category.items" :key="item.id || item.src">
            <div class="gallery-tile">
              <img :src="item.src" :alt="item.alt" class="w-full h-full object-cover" />
            </div>
          </SlidePersonalizado>
        </CarouselPersonalizado>
      </section>
      <div v-if="idx < categories.length - 1" class="gallery-divider"></div>
    </template>
  </div>
</template>

<script>
import CarouselPersonalizado from '@/components/CarouselPersonalizado.vue';
import SlidePersonalizado from '@/components/SlidePersonalizado.vue';
import heroImage from '@/assets/cristal1-scaled.jpg';
import { useHead } from "@vueuse/head";
import { ref, computed, onMounted, onUnmounted } from 'vue';

export default {
  name: "GaleriaPage",
  components: {
    CarouselPersonalizado,
    SlidePersonalizado,
  },
  setup() {
    const windowWidth = ref(window.innerWidth);

    const itemsToShow = computed(() => {
      return windowWidth.value < 768 ? 1 : 3;
    });

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener('resize', handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    useHead({
      title: "Trabajos | Visualiza todos nuestros trabajos",
      meta: [
        {
          name: "description",
          content:
            "Explora nuestra galería y descubre el arte y la pasión detrás de cada uno de nuestros servicios. Inspírate con imágenes de nuestro trabajo y visualiza los resultados que podemos lograr juntos.",
        },
        { property: "og:type", content: "website" },
        {
          property: "og:title",
          content: "Trabajos | Visualiza todos nuestros trabajos",
        },
        {
          property: "og:description",
          content:
            "Explora nuestra galería y descubre el arte y la pasión detrás de cada uno de nuestros servicios. Inspírate con imágenes de nuestro trabajo y visualiza los resultados que podemos lograr juntos.",
        },
        { property: "og:url", content: "https://jeshubeauty.cl/galeria" },
      ],
      link: [{ rel: "canonical", href: "https://jeshubeauty.cl/galeria" }],
    });

    return {
      itemsToShow,
      heroImage,
    };
  },
  computed: {
    categories() {
      return [
        { title: 'Manicure', items: this.itemsManicure },
        { title: 'Pedicure', items: this.itemsPedicure },
        { title: 'Peinados', items: this.itemsPeinados },
        { title: 'Maquillaje Social', items: this.itemsMaquillajeSocial },
        { title: 'Soft Gel', items: this.itemsSoftGel },
        { title: 'Asiático', items: this.itemsAsiatico },
        { title: 'Diseños', items: this.itemsNailArt },
        { title: 'Mani Men', items: this.itemsManiMen },
      ];
    },
  },
  data() {
    return {
      itemsManicure: [
        { src: require("@/assets/Manicure/manicure2.jpg"), alt: "Manicure 2" },
        { src: require("@/assets/Manicure/manicure7.jpg"), alt: "Manicure 7" },
        { src: require("@/assets/Manicure/manicure6.jpg"), alt: "Manicure 6" },

        { src: require("@/assets/Manicure/manicure5.jpg"), alt: "Manicure 5" },
        { src: require("@/assets/Manicure/manicure4.jpg"), alt: "Manicure 4" },

        { src: require("@/assets/Manicure/manicure8.jpg"), alt: "Manicure 8" },
        { src: require("@/assets/Manicure/manicure9.jpg"), alt: "Manicure 9" },
        { src: require("@/assets/Manicure/manicure1.jpg"), alt: "Manicure 1" },
        { src: require("@/assets/Manicure/manicure3.jpg"), alt: "Manicure 3" },
        {
          src: require("@/assets/Manicure/manicure10.jpg"),
          alt: "Manicure 10",
        },
      ],

      itemsPedicure: [
        { src: require("@/assets/Pedicure/pedicure6.jpg"), alt: "Pedicure 6" },

        { src: require("@/assets/Pedicure/pedicure3.jpg"), alt: "Pedicure 3" },
        { src: require("@/assets/Pedicure/pedicure2.jpg"), alt: "Pedicure 2" },
        { src: require("@/assets/Pedicure/pedicure1.jpg"), alt: "Pedicure 1" },
        { src: require("@/assets/Pedicure/pedicure5.jpg"), alt: "Pedicure 5" },

        { src: require("@/assets/Pedicure/pedicure4.jpg"), alt: "Pedicure 4" },
      ],
      itemsMaquillajeNovias: [
        {
          src: require("@/assets/MaquillajePeinado/Maquillaje2.jpg"),
          alt: "Maquillaje Novias 1",
        },
      ],
      itemsMaquillajeSocial: [
        {
          src: require("@/assets/MaquillajePeinado/Maquillaje3.jpg"),
          alt: "Maquillaje 3",
        },

        {
          src: require("@/assets/MaquillajePeinado/Maquillaje5.jpg"),
          alt: "Maquillaje 5",
        },

        {
          src: require("@/assets/MaquillajePeinado/Maquillaje1.jpg"),
          alt: "Maquillaje 1",
        },
        {
          src: require("@/assets/MaquillajePeinado/Maquillaje7.jpg"),
          alt: "Maquillaje 7",
        },
        {
          src: require("@/assets/MaquillajePeinado/Maquillaje6.jpg"),
          alt: "Maquillaje 6",
        },
        {
          src: require("@/assets/MaquillajePeinado/Maquillaje4.jpg"),
          alt: "Maquillaje 4",
        },
        {
          src: require("@/assets/MaquillajePeinado/Maquillaje8.jpg"),
          alt: "Maquillaje 8",
        },
        {
          src: require("@/assets/MaquillajePeinado/Maquillaje9.jpg"),
          alt: "Maquillaje 9",
        },
      ],
      itemsSoftGel: [
        {
          src: require("@/assets/Softgel/softgel8.jpg"),
          alt: "Soft Gel 8",
        },
        {
          src: require("@/assets/Softgel/softgel4.jpg"),
          alt: "Soft Gel 4",
        },
        {
          src: require("@/assets/Softgel/softgel1.jpg"),
          alt: "Soft Gel 1",
        },
        {
          src: require("@/assets/Softgel/softgel2.jpg"),
          alt: "Soft Gel 2",
        },
        {
          src: require("@/assets/Softgel/softgel3.jpg"),
          alt: "Soft Gel 3",
        },

        {
          src: require("@/assets/Softgel/softgel5.jpg"),
          alt: "Soft Gel 5",
        },
        {
          src: require("@/assets/Softgel/softgel6.jpg"),
          alt: "Soft Gel 6",
        },
        {
          src: require("@/assets/Softgel/softgel7.jpg"),
          alt: "Soft Gel 7",
        },
        {
          src: require("@/assets/Softgel/softgel10.jpg"),
          alt: "Soft Gel 10",
        },

        {
          src: require("@/assets/Softgel/softgel9.jpg"),
          alt: "Soft Gel 9",
        },
      ],
      itemsNailArt: [
        {
          src: require("@/assets/Diseños/diseño1.jpg"),
          alt: "Diseño 1",
        },
        {
          src: require("@/assets/Diseños/diseño5.jpg"),
          alt: "Diseño 5",
        },
        {
          src: require("@/assets/Diseños/diseño2.jpg"),
          alt: "Diseño 2",
        },
        {
          src: require("@/assets/Diseños/diseño3.jpg"),
          alt: "Diseño 3",
        },

        {
          src: require("@/assets/Diseños/diseño6.jpg"),
          alt: "Diseño 6",
        },
        {
          src: require("@/assets/Diseños/diseño7.jpg"),
          alt: "Diseño 7",
        },
        {
          src: require("@/assets/Diseños/diseño8.jpg"),
          alt: "Diseño 8",
        },
        {
          src: require("@/assets/Diseños/diseño9.jpg"),
          alt: "Diseño 9",
        },
        {
          src: require("@/assets/Diseños/diseño10.jpg"),
          alt: "Diseño 10",
        },
        {
          src: require("@/assets/Diseños/diseño4.jpg"),
          alt: "Diseño 4",
        },
      ],
      itemsAsiatico: [
        {
          src: require("@/assets/Asiatico/asiatico19.jpg"),
          alt: "Asiatico 19",
        },
        {
          src: require("@/assets/Asiatico/asiatico4.jpg"),
          alt: "Asiatico 4",
        },
        {
          src: require("@/assets/Asiatico/asiatico1.jpg"),
          alt: "Asiatico 1",
        },
        {
          src: require("@/assets/Asiatico/asiatico2.jpg"),
          alt: "Asiatico 2",
        },
        {
          src: require("@/assets/Asiatico/asiatico3.jpg"),
          alt: "Asiatico 3",
        },

        {
          src: require("@/assets/Asiatico/asiatico5.jpg"),
          alt: "Asiatico 5",
        },
        {
          src: require("@/assets/Asiatico/asiatico6.jpg"),
          alt: "Asiatico 6",
        },
        {
          src: require("@/assets/Asiatico/asiatico7.jpg"),
          alt: "Asiatico 7",
        },
        {
          src: require("@/assets/Asiatico/asiatico8.jpg"),
          alt: "Asiatico 8",
        },
        {
          src: require("@/assets/Asiatico/asiatico9.jpg"),
          alt: "Asiatico 9",
        },

        {
          src: require("@/assets/Asiatico/asiatico11.jpg"),
          alt: "Asiatico 11",
        },
        {
          src: require("@/assets/Asiatico/asiatico12.jpg"),
          alt: "Asiatico 12",
        },
        {
          src: require("@/assets/Asiatico/asiatico10.jpg"),
          alt: "Asiatico 10",
        },
        {
          src: require("@/assets/Asiatico/asiatico13.jpg"),
          alt: "Asiatico 13",
        },
        {
          src: require("@/assets/Asiatico/asiatico14.jpg"),
          alt: "Asiatico 14",
        },
        {
          src: require("@/assets/Asiatico/asiatico15.jpg"),
          alt: "Asiatico 15",
        },
        {
          src: require("@/assets/Asiatico/asiatico16.jpg"),
          alt: "Asiatico 16",
        },
        {
          src: require("@/assets/Asiatico/asiatico17.jpg"),
          alt: "Asiatico 17",
        },
        {
          src: require("@/assets/Asiatico/asiatico18.jpg"),
          alt: "Asiatico 18",
        },

        {
          src: require("@/assets/Asiatico/asiatico20.jpg"),
          alt: "Asiatico 20",
        },
      ],
      itemsPeinados: [
        {
          src: require("@/assets/MaquillajePeinado/Peinado4.jpg"),
          alt: "Peinado 4",
        },
        {
          src: require("@/assets/MaquillajePeinado/Peinado5.jpg"),
          alt: "Peinado 5",
        },
        {
          src: require("@/assets/MaquillajePeinado/Peinado1.jpg"),
          alt: "Peinado 1",
        },
        {
          src: require("@/assets/MaquillajePeinado/Peinado2.jpg"),
          alt: "Peinado 2",
        },
        {
          src: require("@/assets/MaquillajePeinado/Peinado6.jpg"),
          alt: "Peinado 6",
        },
        {
          src: require("@/assets/MaquillajePeinado/Peinado3.jpg"),
          alt: "Peinado 3",
        },
      ],

      itemsManiMen: [
        {
          src: require("@/assets/Manimen/manimen3.jpg"),
          alt: "Mani Men 3",
        },

        {
          src: require("@/assets/Manimen/manimen1.jpg"),
          alt: "Mani Men 1",
        },

        {
          src: require("@/assets/Manimen/manimen4.jpg"),
          alt: "Mani Men 4",
        },
        {
          src: require("@/assets/Manimen/manimen5.jpg"),
          alt: "Mani Men 5",
        },

        {
          src: require("@/assets/Manimen/manimen2.jpg"),
          alt: "Mani Men 2",
        },

        {
          src: require("@/assets/Manimen/manimen6.jpg"),
          alt: "Mani Men 6",
        },

        {
          src: require("@/assets/Manimen/manimen7.jpg"),
          alt: "Mani Men 7",
        },
      ],
    };
  },
};
</script>

<style scoped>
.galeria-hero {
  height: 55vh;
  min-height: 440px;
  background-size: cover;
  background-position: center;
}

.gallery-section {
  margin: 3.5rem 0;
}

.gallery-tile {
  margin: 0 6px;
  border-radius: 1rem;
  overflow: hidden;
  aspect-ratio: 4 / 5;
  box-shadow: 0 8px 24px rgba(17, 12, 24, 0.08);
  transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1),
              box-shadow 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.gallery-tile img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

.gallery-tile:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 36px rgba(115, 74, 145, 0.22);
}

.gallery-tile:hover img {
  transform: scale(1.05);
}

.gallery-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(184, 177, 189, 0.6) 50%, transparent 100%);
  margin: 1rem 4rem;
}
</style>
